


import React from "react";

export const PhoneIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-3 h-3 text-gray-80",
    ...props
}) => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}  {...props}>
            <g clipPath="url(#clip0_23869_21199)">
                <path d="M11.0002 8.46005V9.96005C11.0008 10.0993 10.9723 10.2371 10.9165 10.3647C10.8607 10.4923 10.7789 10.6068 10.6762 10.701C10.5736 10.7951 10.4525 10.8668 10.3206 10.9114C10.1887 10.956 10.0489 10.9726 9.91021 10.96C8.37163 10.7929 6.89371 10.2671 5.59521 9.42505C4.38712 8.65738 3.36288 7.63313 2.59521 6.42505C1.7502 5.12065 1.22433 3.63555 1.06021 2.09005C1.04772 1.95178 1.06415 1.81243 1.10846 1.68086C1.15277 1.54929 1.224 1.42839 1.31759 1.32586C1.41119 1.22332 1.52511 1.1414 1.65211 1.08531C1.7791 1.02922 1.91638 1.00018 2.05521 1.00005H3.55521C3.79786 0.99766 4.03311 1.08359 4.21709 1.24181C4.40108 1.40004 4.52125 1.61977 4.55521 1.86005C4.61852 2.34008 4.73594 2.81141 4.90521 3.26505C4.97248 3.44401 4.98704 3.63851 4.94716 3.82549C4.90729 4.01247 4.81464 4.1841 4.68021 4.32005L4.04521 4.95505C4.75699 6.20682 5.79344 7.24327 7.04521 7.95505L7.68021 7.32005C7.81616 7.18562 7.98779 7.09297 8.17477 7.0531C8.36175 7.01322 8.55625 7.02778 8.73521 7.09505C9.18885 7.26432 9.66018 7.38174 10.1402 7.44505C10.3831 7.47931 10.6049 7.60165 10.7635 7.7888C10.922 7.97594 11.0063 8.21484 11.0002 8.46005Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_23869_21199">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
};

